import * as THREE from 'three'
import Experience from '../../Experience'

import anim from '../../Utils/Anim'
export default class Building {
    constructor(position, model, materials) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time
        // 
        this.position = position
        this.materials = materials




        this.mesh = model.clone()
        //    

        this.setBatiment()
        this.appear()

        // 
        this.setDebug()


        setTimeout(() => {
            this.destroy()
        }, 15000)



    }
    setBatiment() {
        this.vitres = []
        this.mesh.scale.set(0.1, 0.1, 0.1)
        this.mesh.position.set(this.position.x, -5, this.position.z)
        this.building = new THREE.Group()

        // Ajoute immédiatement à la scène pour que les matrices soient bien calculées
        this.building.add(this.mesh)
        this.scene.add(this.building)

        this.mesh.traverse((child) => {
            if (child.name === 'batiment') {
                this.batiment = child
                this.batiment.material = this.materials.body
                this.batiment.layers.enable(1)
            } else if (child.name.includes('vitre')) {
                child.visible = false
                this.vitres.push(child)
            }
        })

        this.vitresBlack = []
        this.vitreswhite = []

        this.vitres.forEach((v) => {
            const random = Math.random()
            if (random < 0.1) {
                this.vitreswhite.push(v)
            } else {
                this.vitresBlack.push(v)
            }
        })

        const vitreGeometry = new THREE.PlaneGeometry(1.35, 1.9)
        this.blackVitres = new THREE.InstancedMesh(vitreGeometry, this.materials.black, this.vitresBlack.length)
        this.whiteVitres = new THREE.InstancedMesh(vitreGeometry, this.materials.white, this.vitreswhite.length)
        this.blackVitres.layers.enable(1)
        this.whiteVitres.layers.enable(1)


        // ✅ updateMatrixWorld après ajout à la scène
        this.mesh.updateWorldMatrix(true, true)

        this.vitresBlack.forEach((v, i) => {
            const matrix = new THREE.Matrix4()
            v.updateWorldMatrix(true, true)
            matrix.copy(v.matrixWorld)
            this.blackVitres.setMatrixAt(i, matrix)
        })

        this.vitreswhite.forEach((v, i) => {
            const matrix = new THREE.Matrix4()
            v.updateWorldMatrix(true, true)
            matrix.copy(v.matrixWorld)
            this.whiteVitres.setMatrixAt(i, matrix)
        })

        this.blackVitres.instanceMatrix.needsUpdate = true
        this.whiteVitres.instanceMatrix.needsUpdate = true

        this.building.add(this.blackVitres)
        this.building.add(this.whiteVitres)
    }

    appear() {
        anim.to(this.building.position, {
            y: this.position.y,
            duration: 2 + Math.random(),
            easing: 'power3.out',
        })
    }
    destroy() {
        if (!this.building) return; // Si this.building est null ou undefined, on arrête la fonction

        // Animation de disparition
        anim.to(this.building.position, {
            y: -10,
            duration: 1,
            easing: 'power3.in',
            onComplete: () => {
                // Supprime les enfants du groupe
                this.building?.traverse((child) => {
                    if (child.isMesh || child.isInstancedMesh) {
                        // Libère les géométries et matériaux
                        if (child.geometry) child.geometry.dispose()
                        if (child.material) {
                            if (Array.isArray(child.material)) {
                                child.material.forEach((m) => m.dispose())
                            } else {
                                child.material.dispose()
                            }
                        }
                    }
                })

                // Retire le groupe de la scène
                this.scene.remove(this.building)

                // Nettoie les références
                this.mesh = null
                this.batiment = null
                this.blackVitres = null
                this.whiteVitres = null
                this.building = null
                this.vitres = []
                this.vitresBlack = []
                this.vitreswhite = []
            }
        })
    }



    setDebug() {
        if (this.experience.debug.active) {
            const ui = this.experience.debug.ui



        }
    }
    update() {

    }

}